module.exports = __webpack_public_path__ + "img/fashion_97.86aca05e.jpg";